/**
 * Error types for dashboard reconciler.
 *
 * @module reconciler/errors
 */

/**
 * Error thrown when JSX to JSON conversion fails.
 */
export class DashboardRenderError extends Error {
  public readonly elementType?: string;

  constructor(message: string, elementType?: string, cause?: unknown) {
    super(message, { cause });
    this.name = 'DashboardRenderError';
    this.elementType = elementType;
  }
}
